export const PATH_CONSTANTS = {
  PRIVACY_POLICY: "home/privacy-policy",
  TERMS_OF_USE: "home/term-of-use",
};
